export const API_URL = 'https://redakcija.gyvenukaune.lt/wp-json/wp/v2';
export const AUTH_HEADER = 'Basic ' + btoa('admin:5xeJ mB0Y V3Xm qm2K R6k2 UAuT');
export const BASE_URL = 'https://redakcija.gyvenukaune.lt/';
export const CDN_URL = 'https://i0.wp.com/redakcija.gyvenukaune.lt';
export const BASE_URL_NO_SLASH = 'https://redakcija.gyvenukaune.lt';
export const DEFAULT_IMAGE_URL = 'https://redakcija.gyvenukaune.lt/wp-content/uploads/2023/10/brigita-sabaliauskaite-84040985.jpg';